import joi from 'joi';
import { dateDefault } from './types.def';

export const form = joi.object({
	schema: joi.string(),
	type: joi.string(),
	id: joi.string(),
	url: joi.string(),
	rootFormId: joi.object({
		id: joi.string(),
		url: joi.string(),
	}),
	revision: joi.object({
		id: joi.string(),
		url: joi.string(),
	}),
	name: joi.string(),
	displayVersion: joi.number(),
	description: joi.string(),
	createdAt: dateDefault,
	updatedAt: dateDefault,
	fields: joi.array().items(
		joi.object({
			id: joi.string(),
			type: joi.string(),
			name: joi.string(),
		})
	),
});
